import React from 'react';
import styles from './SocialMediaLogos.module.scss';
import { ILogos, ILogosData } from './SocialMediaLogos.interface';

export const SocialMediaLogos: React.FC<ILogos> = ({ loginProvidersData, urlTocTocImg }) => {

	return (
		<section className={styles.contentCtr}>
			<div className={`${styles.logosCtr} ${loginProvidersData.length <= 2 ? styles.logosCtrFew : ''}`}>
				{loginProvidersData.map((logo: ILogosData, index) => (
					<a key={`${logo.alt}-${index}`} href={logo.url}>
						<div className={styles.logoCtr}>
							<img src={`${urlTocTocImg}/toctocsso/img/${logo.img}`} alt={logo.alt} />
							{loginProvidersData.length <= 2 && <span>Iniciar sesión con {logo.name}</span>}
						</div>
					</a>
				))}
			</div>
			<div className={styles.underlineCtr}>
				<span>O puedes</span>
			</div>
		</section>
	)
}

export default SocialMediaLogos;